"use client";

import Link from "next/link";
import Multimedia from "@sharedComponents/multimedia";
import ReactHtmlParser from "react-html-parser";
import styles from "./image-with-text-on-left.module.scss";
import { getProductRoute } from "@constants/routes";
import { useStoreContext } from "@components/store/provider";

const ImageWithTextOnLeft = ({ editingAllowed, data, children }) => {
  const { imageOne, content, linkedResource } = data;
  const contentData = JSON.parse(content.replaceAll("=>", ":"));
  const { storeBasePath } = useStoreContext();

  const renderAddToBagBtn = () => {
    const productSlug = linkedResource?.slug;
    if (productSlug)
      return (
        <div className={styles.addBtnBlock}>
          <Link
            href={getProductRoute({ storeBasePath, productSlug })}
            className={`btn-primary ${styles.addBagBtn}`}
            prefetch={false}
          >
            {contentData.button_text || "VIEW MORE DETAILS"}
          </Link>
        </div>
      );
  };

  return (
    <section className={styles.imageWithLeftText}>
      <div
        className={`t-bg-3 ${styles.overlayBg}`}
        {...(contentData?.background_color && {
          style: { backgroundColor: contentData?.background_color },
        })}
      />
      <article className={styles.containerClass}>
        <div className={styles.dataRow}>
          <aside className={styles.colLeft}>
            <article className={styles.dataText}>
              <div>{ReactHtmlParser(contentData.rte_content)}</div>
              {renderAddToBagBtn()}
            </article>
          </aside>
          <div className={styles.colRight}>
            <div className={`${styles.imgHelperBox}`}>
              <Multimedia
                type="image"
                src={imageOne}
                alt=""
                className={`img-fluid ${styles.imgCopy}`}
                width={580}
                height={385}
              />
            </div>
          </div>
        </div>
      </article>
      {editingAllowed && children}
    </section>
  );
};

export default ImageWithTextOnLeft;
